<template>
  <span>
    {{ creditCard.brand }}
    {{ $tt('customCreditCardLast4') }}
    {{ creditCard.last4 }}
    &#8729;
    {{ getExpireText() }}
  </span>
</template>

<script>
import numeral from 'numeral'
export default {
  name: 'CreditCardDescription',
  props: {
    creditCard: {
      required: true,
      type: Object,
    },
  },
  methods: {
    getExpireText() {
      return numeral(this.creditCard.expMonth).format('00') + '/' + this.creditCard.expYear
    },
  },
}
</script>

<style scoped></style>
